import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { BreadCrumb } from "../components/BreadCrumb";
import { PiUserList } from "react-icons/pi";
import { TfiPackage } from "react-icons/tfi";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { SlLock } from "react-icons/sl";
import { MisDatos } from "../../assets/MisDatos";
import { CambiarContrasena } from "../../assets/CambiarContrasena";

export const Perfil = () => {

    const navigate = useNavigate();

    const items = [
        {
            title: "Mis datos",
            icon: <PiUserList size={'18px'} />,
            content: <MisDatos />,
            url: "/mis-datos"
        },
        {
            title: "Seguir mi pedido",
            icon: <TfiPackage size={'16px'} />,
            content: "",
            url: ""
        },
        {
            title: "Mis boletas",
            icon: <LiaFileInvoiceDollarSolid size={'18px'} />,
            content: "",
            url: ""
        },
        {
            title: "Cambiar Contraseña",
            icon: <SlLock size={'18px'} />,
            content: <CambiarContrasena />,
            url: "/cambiar-contrasena"
        }
    ]

    const [selectedIndex, setSelectedIndex] = useState(0)

    return (
        <>
            <div className="contactanos-page font-family-montserrat">
                <div>
                    <BreadCrumb productoNombre={items[selectedIndex].title} />
                </div>

                <div className="lista-container lista-container-perfil">
                    <ul className="info-lista info-lista-perfil pointer">
                        {items.map((item, index) => (
                            <li
                                key={index}
                                className={`lista-item-perfil  lista-item ${selectedIndex === index ? "highlighted" : ""}`}
                                onClick={() => setSelectedIndex(index)}
                            >
                                {item.icon && <span className="icon">{item.icon}</span>}
                                {item.title}
                            </li>
                        ))}
                        <li className="footer-perfil">
                            Ultimo pedido en curso
                            <span>No hay pedidos activos</span>
                        </li>
                    </ul>
                </div>
                <div className="dashed-line"></div>

                <div className="texto-container">
                    {items[selectedIndex].content}
                </div>
            </div>
        </>
    )

}   